(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const initReveal = () => {
    const items = document.querySelectorAll('.gg-reveal, .gg-reveal-image');
    if (!items.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      items.forEach((el) => el.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
    );

    items.forEach((el) => observer.observe(el));
  };

  const initHeader = () => {
    const header = document.querySelector('[data-gg-header]');
    if (!header) return;

    const sticky = header.dataset.sticky !== 'false';
    const isHome = document.body.classList.contains('template-index');
    const transparent = header.dataset.transparent === 'true' && isHome;
    const wrap = header.closest('.gg-header-wrap');

    if (transparent) {
      document.body.classList.add('gg-has-transparent-header');
      header.classList.add('is-transparent');
      header.classList.remove('is-solid');
    } else {
      document.body.classList.remove('gg-has-transparent-header');
      header.classList.remove('is-transparent');
      header.classList.add('is-solid');
    }

    const onScroll = () => {
      const y = window.scrollY || document.documentElement.scrollTop;
      const scrolled = y > 24;
      if (transparent) {
        header.classList.toggle('is-scrolled', scrolled);
        header.classList.toggle('is-transparent', !scrolled);
      } else if (sticky) {
        header.classList.toggle('is-scrolled', scrolled);
      }
      if (sticky && wrap) {
        wrap.classList.toggle('is-sticky', y > 8);
      }
    };

    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  };

  const initDrawer = () => {
    const drawer = document.querySelector('[data-gg-drawer]');
    if (!drawer) return;

    const openers = document.querySelectorAll('[data-gg-drawer-open]');
    const closers = drawer.querySelectorAll('[data-gg-drawer-close]');

    const open = () => {
      drawer.classList.add('is-open');
      document.body.classList.add('gg-drawer-open');
      const closeBtn = drawer.querySelector('[data-gg-drawer-close]');
      if (closeBtn) closeBtn.focus();
    };

    const close = () => {
      drawer.classList.remove('is-open');
      document.body.classList.remove('gg-drawer-open');
    };

    openers.forEach((btn) => btn.addEventListener('click', open));
    closers.forEach((btn) => btn.addEventListener('click', close));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') close();
    });
  };

  const initAnnouncementCarousel = () => {
    const root = document.querySelector('[data-gg-announcement-carousel]');
    if (!root) return;

    const slides = Array.from(root.querySelectorAll('[data-gg-announcement-slide]'));
    if (slides.length < 2) return;

    let index = 0;
    const textEl = root.querySelector('[data-gg-announcement-active]');

    const render = () => {
      const slide = slides[index];
      if (!textEl || !slide) return;
      textEl.innerHTML = slide.innerHTML;
    };

    root.querySelector('[data-gg-announcement-prev]')?.addEventListener('click', () => {
      index = (index - 1 + slides.length) % slides.length;
      render();
    });

    root.querySelector('[data-gg-announcement-next]')?.addEventListener('click', () => {
      index = (index + 1) % slides.length;
      render();
    });

    render();
  };

  const boot = () => {
    initReveal();
    initHeader();
    initDrawer();
    initAnnouncementCarousel();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
